// extracted by mini-css-extract-plugin
module.exports = {"info":"_43adbb7"};